export default "__VITE_ASSET__l7ZBBgbt__"